import {Grid, makeStyles, Typography} from "@material-ui/core";
import HighLightItem from "./highlightGridItem";
import {useDispatch, useSelector} from "react-redux";
import {useCallback, useEffect, useState} from "react";
import UtilService from "../../../../../../helper/service";
import AnalyzeKeyMomentPopOut from "../../../../../atoms/creator/analyzeKeyMomentPopout";
import {addOverviewToAnalysisKeyMoment} from "../../../../../../store/actions/creator/analysis";
import roles from "../../../../../../helper/roles";
import {useHistory} from "react-router";
import VideoImage from "./videoImage";

const useStyles = makeStyles(() => ({
  /*root: {
    paddingTop: 64,
    '@media screen and (max-width: 600px)': {
      paddingTop: 30
    }
  },*/
  foo: {},
  keyMoment: {
    position: 'absolute',
    fontSize: 28,
    fontFamily: 'roboto-bold',
    color: '#FFFFFF',
    opacity: 0.5,
    letterSpacing: 3,
    paddingLeft: 50,
    paddingTop: 120,
    textTransform: 'uppercase',
    '@media (min-width: 992px) and (max-width: 1020px)': {
      fontSize: 24,
      paddingLeft: 30,
      paddingTop: 90
    },
    '@media (min-width: 1020px) and (max-width: 1100px)': {
      paddingLeft: 40,
      paddingTop: 100
    },
  },
  imgTime: {
    position: 'absolute',
    fontSize: 75,
    fontFamily: 'Spartan-bold',
    color: '#FFFFFF',
    paddingLeft: 50,
    paddingTop: 180,
    '@media (min-width: 992px) and (max-width: 1020px)': {
      fontSize: 65,
      paddingLeft: 30,
      paddingTop: 130
    },
    '@media (min-width: 1020px) and (max-width: 1100px)': {
      paddingLeft: 40,
      paddingTop: 140
    },
  },
  dotIcon: {
    position: 'absolute',
    width: 24,
    height: 24,
    borderRadius: 12,
    backgroundColor: '#FFFFFF',
    opacity: 0.5,
    marginLeft: 70,
    marginTop: 70,
    '@media (min-width: 992px) and (max-width: 1020px)': {
      width: 20,
      height: 20,
      marginLeft: 40,
      marginTop: 50
    },
    '@media (min-width: 1020px) and (max-width: 1100px)': {
      marginLeft: 60,
      marginTop: 60
    },
  },




  sectionTitle: {
    fontSize: 24,
    fontFamily: 'Spartan-bold',
    color: '#697683'
  },
  cardSection: {
    borderRadius: 20,
    marginTop: 25,
    background: '#fff',
    boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)"
  },
  pdfCardSection: {
    borderRadius: 20,
    marginTop: 25,
    background: '#fff',
    border: '1px solid rgba(0, 0, 0, 0.1)',
  },
  content: {
    padding: '45px 20px 20px 20px!important',
    '@media screen and (max-width: 992px)': {
      padding: '20px!important'
    }
  },
  mainGrid: {
    maxWidth: '904px'
  },
  momentContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    flexWrap: 'wrap'
  },
  categoryTitle: {
    fontSize: 16,
    fontFamily: 'roboto-regular',
    color: '#697683',
    marginTop: 40,
    lineHeight: 1.5
  },
  bold: {
    fontSize: 16,
    fontFamily: 'roboto-bold'
  },
  image: {
    width: 495,
    height: 330,
    borderRadius: 15,
    cursor: 'pointer',
    position: 'relative',
    overflow: "hidden",
    '@media (min-width: 992px) and (max-width: 1020px)': {
      width: 315,
      height: 210
    },
    '@media (min-width: 1020px) and (max-width: 1100px)': {
      width: 360,
      height: 240
    },
    '@media (min-width: 1100px) and (max-width: 1300px)': {
      width: 396,
      height: 264
    },
    '& img': {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      position: "absolute",
      top: "0",
      left: "0"
    }
  },
  
  
  bestTitle: {
    fontFamily: 'Spartan-bold',
    fontSize: '24px',
    lineHeight: '26px',
    color: '#697683'
  },
  icon: {
    width: '45px',
    height: '45px',
    '@media (min-width: 992px) and (max-width: 1020px)': {
      width: '30px',
      height: '30px'
    },
  },
  bestValue: {
    fontFamily: 'Spartan-extrabold',
    fontSize: '30px',
    paddingLeft: '10px',
    paddingRight: '10px',
    marginTop: '6px'
  },
  bestIndicator: {
    fontFamily: 'Spartan-bold',
    fontSize: '23px',
    marginTop: '6px',
    textTransform: 'uppercase'
  },
  epochTime: {
    fontFamily: 'Spartan-extrabold',
    fontSize: '30px',
    color: '#8191A1',
    marginTop: '7px',
    paddingLeft: '10px'
  },
  bestDescription: {
    fontFamily: 'roboto-medium',
    fontSize: '14px',
    color: '#8192A2',
    marginTop: '20px'
  },
  /*infoSection: {
    marginLeft: '40px'
  }*/
  /*,
  bestSection: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '0px',
    paddingRight: '0px',
    marginBottom: '25px'
  }*/
}));

interface IProps {
  bestMoments: any[],
  worstMoments: any[],
  session: any;
  isMobile: boolean;
}

const BestMoments = (props: IProps) => {
  const classes = useStyles();
  const { width } = UtilService.useWindowSize();
  const { bestMoments, worstMoments, session, isMobile } = props;
  const history = useHistory();
  const dispatch = useDispatch();
  const { settings, cliped, analyseStart, stimulus } = useSelector((state: any) => state.analysis);
  const { stimulusList } = useSelector((state: any) => state.creatorExperienceManager);
  const { pdfLoading } = settings;

  const currentSessionCode = localStorage.getItem("session_code") ? localStorage.getItem("session_code") : "";
  const [bestList, setBestList] = useState<any[]>([]);
  const [worstList, setWorstList] = useState<any[]>([]);
  const [dotImg, setDotImg] = useState('');
  // const [bestMomentThumb, setBestMomentThumb] = useState('');
  const [bestMomentItem, setBestMomentItem] = useState<any>(null);
  const [bestImmersionIndex, setBestImmersionIndex] = useState<any>(null);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [overlay, setOverlay] = useState(null);
  // const [worstMomentThumb, setWorstMomentThumb] = useState('');
  const [worstMomentItem, setWorstMomentItem] = useState<any>(null);
  const [worstImmersionIndex, setWorstImmersionIndex] = useState<any>(null);

  useEffect(() => {
    if (bestMoments.length > 0) {
      if (cliped) {
        const clippedBestMoments = [
          ...bestMoments.filter((moment: any) =>
            (cliped['start_clip'] <= moment['epoch_start'] && cliped['end_clip'] >= moment['epoch_start'])
          )
        ].sort(function (a, b) {
          return b.immersion_index.overall_index - a.immersion_index.overall_index
        });
        const slicedClippedBestMoments = clippedBestMoments.slice(0, 4);
        if (width >= 1010) {
          getBestMomentInfo(slicedClippedBestMoments[0]);
          setBestList(slicedClippedBestMoments.slice(1, slicedClippedBestMoments.length));
        } else if (width > 0 && width < 1010) {
          setBestList(slicedClippedBestMoments);
        }
      } else {
        const _bestMoments = [...bestMoments].sort(function (a, b) {
          return b.immersion_index.overall_index - a.immersion_index.overall_index
        });
        const slicedBestMoments = _bestMoments.slice(0, 4);
        if (width >= 1010) {
          getBestMomentInfo(slicedBestMoments[0]);
          setBestList(slicedBestMoments.slice(1, slicedBestMoments.length));
        } else if (width > 0 && width < 1010) {
          setBestList(slicedBestMoments);
        }
      }
    }
    if (worstMoments.length > 0) {
      if (cliped) {
        const clippedWorstMoments = [
          ...worstMoments.filter((moment: any) =>
            (cliped['start_clip'] <= moment['epoch_start'] && cliped['end_clip'] >= moment['epoch_start'])
          )
        ].sort(function (a, b) {
          return a.immersion_index.overall_index - b.immersion_index.overall_index
        });
        const slicedClippedWorstMoments = clippedWorstMoments.slice(0, 4);
        if (width >= 1010) {
          getWorstMomentInfo(slicedClippedWorstMoments[0]);
          setWorstList(slicedClippedWorstMoments.slice(1, slicedClippedWorstMoments.length));
        } else if (width > 0 && width < 1010) {
          setWorstList(slicedClippedWorstMoments);
        }
      } else {
        const _worstMoments = [...worstMoments].sort(function (a, b) {
          return a.immersion_index.overall_index - b.immersion_index.overall_index
        });
        const slicedWorstMoments = _worstMoments.slice(0, 4);
        if (width >= 1010) {
          getWorstMomentInfo(slicedWorstMoments[0]);
          setWorstList(slicedWorstMoments.slice(1, slicedWorstMoments.length));
        } else if (width > 0 && width < 1010) {
          setWorstList(slicedWorstMoments);
        }
      }
    }
  }, [cliped, bestMoments, worstMoments, width]);

  useEffect(() => {
    if (stimulusList && stimulusList.length > 0) {
      if (stimulusList[0].thumbnails && stimulusList[0].thumbnails.length > 0)
        setDotImg(stimulusList[0].thumbnails[0].url);
    }
  }, [stimulusList]);

  const getBestMomentInfo = (moment: any) => {
    setBestMomentItem(moment);
    const immersionIndex = (moment && moment.immersion_index && Object.keys(moment.immersion_index).length !== 0)
      ? moment.immersion_index
      : null;
    setBestImmersionIndex(immersionIndex);
    if (moment && moment.thumbnail) {
      UtilService.convertBase64Uri(moment.thumbnail, 630, 370, function () {
        // setBestMomentThumb(dataUri);
      });
    } else {
      // setBestMomentThumb('');
    }
  };

  const getWorstMomentInfo = (moment: any) => {
    setWorstMomentItem(moment);
    const immersionIndex = (moment && moment.immersion_index && Object.keys(moment.immersion_index).length !== 0)
      ? moment.immersion_index
      : null;
    setWorstImmersionIndex(immersionIndex);
    if (moment && moment.thumbnail) {
      UtilService.convertBase64Uri(moment.thumbnail, 630, 370, function () {
        // setWorstMomentThumb(dataUri);
      });
    } else {
      // setWorstMomentThumb('');
    }
  };

  const getMomentsRows = (moments: any[], type: string) => {
    return (
      <>
        {
          moments.map((moment, i) => (
            <HighLightItem isMobile={isMobile} session={session} type={type} moment={moment} key={`${type}-mod-${i}`} />
          ))
        }
      </>
    )
  };

  const getEpochTime = useCallback((epoch_time: number) => {
    if (session['session_type'] === 'ASYNC') {
      return UtilService.convertHighlightsTime(epoch_time)
    } else {
      return UtilService.convertHighlightsTime(epoch_time - Number(analyseStart));
    }
  }, [session, analyseStart]);

  const getColor = (type: string) => {
    switch (type) {
      case 'best':
        return '#1CB858';
      case 'worst':
        return '#ED564A';
      default:
        return '#1CB858';
    }
  };

  const handlePopup = (e: any, type: string) => {
    setAnchorEl(e.currentTarget);
    const overlay = type === 'best'
      ? getPopupData(bestMomentItem, bestImmersionIndex)
      : getPopupData(worstMomentItem, worstImmersionIndex);
    setOverlay(overlay);
  };

  const getPopupData = (moment: any, immersionIndex: any) => {
    const start = cliped ? cliped.start_clip - analyseStart : 0;
    const graphStart = cliped ? cliped.start_clip : analyseStart;
    const segment_start = (moment?.epoch_start) - (session['session_type'] === 'ASYNC' ? 0 : graphStart);
    const segment_end = (moment?.end ? moment.end : moment?.epoch_end) - (session['session_type'] === 'ASYNC' ? 0 : graphStart);

    const customData: any = {
      overall_index: immersionIndex['overall_index'],
      context_indicator: immersionIndex['context_indicator'],
      safety_index: moment.safety_index.overall_index > 1 ? moment.safety_index.overall_index : '--',
      safety_indicator: moment.safety_index.overall_index > 1 && moment.safety_index.context_indicator,
      safety_color: moment.safety_index.color_indicator,
      color: moment.immersion_index.color_indicator,
      type: 'Key Moment',
      title: '',
      segment_start: UtilService.getTimeLabel(segment_start, 1, session['session_type'] === 'ASYNC' ? 0 : start),
      segment_length: UtilService.getTimeLabel(segment_end - segment_start, 1, 0),
      segment_end: UtilService.getTimeLabel(segment_end, 1, session['session_type'] === 'ASYNC' ? 0 : start),
      start: moment.epoch_start,
      end: moment.epoch_end,
      length: moment.epoch_end - moment.epoch_start,
      epoch_start: moment.epoch_start,
    };
    return customData;
  };

  const goAnalyzeTab = (keyMoment: any) => {
    dispatch(addOverviewToAnalysisKeyMoment(keyMoment));
    const userData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";
    let url = `/creator/experience-manager/analyze/${currentSessionCode}`;
    if (!!userData) {
      if (UtilService.checkTrialAccess(userData, roles['trial']['experiences'])) {
        url = `/subscriber/creator/experience-manager/analyze/${currentSessionCode}`;
      }
    }
    history.push({
      pathname: url,
    })
  };

  if (pdfLoading) {
    //
  }
if (dotImg) {}

  return (
    ((bestList.length > 0 || bestMomentItem) || (worstList.length > 0 || worstMomentItem)) ? (
      
      <Grid container spacing={3} >

        {(bestList.length > 0 || bestMomentItem) &&
          
           <>
             

                <Grid item xs={6} sm={6} >
                <div
                          //aria-describedby={'XXXXsimple-popover'}
                          className={classes.foo}
                          onClick={(e) => handlePopup(e, 'best')}
                          style={{ backgroundColor: stimulus ? '#000' : getColor('best') }}
                        >

                          {stimulus && <VideoImage
                            video={stimulus?.play_url ? stimulus?.play_url : stimulus?.stimulus_link}
                            stimulus_video_length={stimulus?.stimulus_video_length}
                            videoStart={bestMomentItem?.epoch_start}
                            videoEnd={bestMomentItem?.epoch_end}
                          />}

                          {/*

                          {dotImg === "" && <div id={'dot_icon'} className={classes.dotIcon} />}
                          
                          
                          <span className={classes.keyMoment}>KEY MOMENT</span>
                          <span className={classes.imgTime}>
                            {bestMomentItem && getEpochTime(bestMomentItem['epoch_start'])}
                          </span>
                          */}

                        </div>
                        {overlay && <AnalyzeKeyMomentPopOut
                          anchorEl={anchorEl}
                          overlay={overlay}
                          setAnchorEl={setAnchorEl}
                          goAnalyzeTab={goAnalyzeTab}
                          overview={true}
                        />}
                      

                </Grid>
                        
                 
                <Grid item xs={6} sm={6}>
                        <div className={classes.bestTitle}>WOW! Your most immersive moment killed it!</div>
                        
                        <div style={{ display: 'flex', alignItems: 'center', color: '#1CB858', margin: '15px 0px' }}>
                          <img className={classes.icon} src={`/assets/icons/overview/best-moment.svg`} alt='Moment' />
                          <div className={classes.bestValue}>
                            {(bestImmersionIndex && bestImmersionIndex['overall_index'] > 1) ? bestImmersionIndex['overall_index'] : '--'}
                          </div>
                          <div className={classes.bestIndicator}>
                            {(bestImmersionIndex && bestImmersionIndex['overall_index'] > 1) ? bestImmersionIndex['context_indicator'] : '--'}
                          </div>
                        </div>


                        <div style={{ display: 'flex', alignItems: 'center', color: '#1CB858', marginBottom: '10px' }}>
                          <img className={classes.icon} src={`/assets/icons/overview/best-value-clock.svg`} alt='Clock' />
                          <div className={classes.epochTime}>
                            {bestMomentItem && `${getEpochTime(bestMomentItem['epoch_start'])} to ${getEpochTime(bestMomentItem['epoch_end'])}`}
                          </div>
                        </div>
                        <div className={classes.bestDescription}>
                          Your audience is extremely likely to remember this moment. Consider placing key information around this.
                        </div>
                        <div className={classes.bestDescription}>
                          Click the image on the left and “View in Timeline” to see what was happening at this moment.
                        </div>
                </Grid>
                
                {getMomentsRows(bestList, 'best')}
               

             
              
                </>
            
            }
       
       </Grid> 
      
    ) : <>
    
    <Grid container direction={'column'} spacing={3} wrap={'wrap'} alignItems={'center'} alignContent={'center'}>
      <Grid item xs={6} style={{padding: '20px'}}>
      <img src={'/assets/images/man-with-check.svg'} alt={'Wahoo!'} style={{width: '100%'}}/>
      <Typography variant="h3" color="textSecondary" component="p" className={classes.bestTitle}>
        Hmmmmm...
      </Typography>
      <Typography variant="body2" color="textSecondary" component="p">
        We didn&apos;t find any moments in this content that were statistically significant. That&apos;s not great.  
        Usually, you want to see amazing moments overlap with your call to action. You might consider re-testing the content or re-editing the content to create some great moments.
      </Typography>
      </Grid>
    </Grid>
    
    </>
  );
};

export default BestMoments;